import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, ProtectedRoute } from "./context/AuthContext";
import { SiteProvider } from "./context/SiteContext";
import { Layout } from "./components/site/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import OrderRequest from "./pages/OrderRequest";
import Ordering from "./pages/Ordering";
import Contact from "./pages/Contact";
import Shop from "./pages/Shop";
import ShopItemPage from "./pages/ShopItem";
import { PaymentCancel, PaymentSuccess, PayQuote } from "./pages/Payments";
import AdminShop from "./pages/admin/AdminShop";
import CustomerAuth from "./pages/CustomerAuth";
import MyOrders from "./pages/MyOrders";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminRequests from "./pages/admin/AdminRequests";
import AdminGallery from "./pages/admin/AdminGallery";
import AdminReviews from "./pages/admin/AdminReviews";
import AdminHelp from "./pages/admin/AdminHelp";
import AdminPromotions from "./pages/admin/AdminPromotions";
import AdminSiteInfo from "./pages/admin/AdminSiteInfo";

function App() {
  return (
    <AuthProvider>
      <SiteProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/order" element={<OrderRequest />} />
            <Route path="/ordering" element={<Ordering />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/:id" element={<ShopItemPage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/pay/:id" element={<PayQuote />} />
            <Route path="/account/login" element={<CustomerAuth />} />
            <Route path="/account" element={<ProtectedRoute><MyOrders /></ProtectedRoute>} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute admin><AdminLayout /></ProtectedRoute>}>
            <Route index element={<AdminRequests />} />
            <Route path="gallery" element={<AdminGallery />} />
            <Route path="reviews" element={<AdminReviews />} />
            <Route path="promotions" element={<AdminPromotions />} />
            <Route path="shop" element={<AdminShop />} />
            <Route path="site" element={<AdminSiteInfo />} />
            <Route path="help" element={<AdminHelp />} />
          </Route>
        </Routes>
      </BrowserRouter>
      </SiteProvider>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
